import { useState } from 'react';
import { EstateWorkItem } from 'queries';

import { Button } from 'common/button';

import AssignAdminPointPersonModal from './assign-admin-point-person-modal';

type AdminPointPersonProps = {
  estateWorkItem: EstateWorkItem;
  refetchEstateWorkItems: () => void;
};

const AdminPointPerson = ({ estateWorkItem, refetchEstateWorkItems }: AdminPointPersonProps) => {
  const [isSetPointPersonModalOpen, setIsSetPointPersonModalOpen] = useState(false);

  const { assignedTsa } = estateWorkItem;

  return (
    <>
      {isSetPointPersonModalOpen && (
        <AssignAdminPointPersonModal
          onClose={() => setIsSetPointPersonModalOpen(false)}
          estateWorkItem={estateWorkItem}
          refetchEstateWorkItems={refetchEstateWorkItems}
        />
      )}

      <Button
        size="xsmall"
        color={assignedTsa ? 'primary' : 'secondary'}
        onClick={() => setIsSetPointPersonModalOpen(true)}
      >
        {assignedTsa?.firstName ? assignedTsa.firstName : 'Assign Admin Point Person'}
      </Button>
    </>
  );
};
export default AdminPointPerson;
